<template>
    <input-text :error="error" v-model="count" @keypress="checkDecimals" />
</template>

<script>
import InputText from "./InputText";
export default {
    components: {
        InputText
    },
    props: {
        value: [Number, String],
        error: Array,
        maxDecimals: {
            default: 2,
            type: Number,
        }
    },

    data() {
        return {
            // Intermediate variable is for preserving decimal delimiter when editing decimals.
            intermediate: 0,
        }
    },

    watch: {
        value(value) {
            if (parseFloat(value) !== parseFloat(this.intermediate)) {
                this.intermediate = value
            }
        }
    },

    mounted() {
        this.intermediate = this.value
    },

    computed: {
        count: {
            get() {
                return this.intermediate
            },
            set(input) {
                if (typeof input !== 'string') {
                    return
                }

                let value = input.replace(/,/, '.')

                this.$set(this, 'intermediate', value)
                this.$emit('input', value)
            }
        }
    },
    methods: {
        checkDecimals ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
            let value = $event.target.value ? $event.target.value : this.intermediate

            if (value === null) {
                return;
            }

            // Allow only numbers, dot, and comma
            if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46) && (keyCode !== 44) && (keyCode !== 45)) {
                $event.preventDefault()
            }

            // Allow one delimiter
            const delimiters = value.indexOf('.') !== -1 || value.indexOf(',') !== -1
            if ((keyCode === 46 || keyCode === 44) && delimiters > 0) {
                $event.preventDefault()
            }

            // Restrict to 2 decimal places
            /* if(value.indexOf(".") > -1 && (value.split('.')[1].length > this.maxDecimals-1)){
                $event.preventDefault()
            } */
        }
    }
}
</script>
